export default function useUsageData(businessId: MaybeRefOrGetter<string>) {
  const { $api } = useNuxtApp()

  const {
    data: usageData,
    pending: isLoading,
    refresh: fetchUsageData,
  } = useLazyApi(() => `/api/businesses/${toValue(businessId)}/subscriptions/usage`)

  // default is null so the loading skeleton is shown until the data resolves
  const seatsAvailableForInvites = computed(() => usageData.value?.seats.availableInvites ?? null)

  const isUpdatingUsedSeats = ref<boolean>(false)
  /**
   * Updates the number of seats used by the business.
   *
   * We use a timestamp to let Stripe know about the cutoff date when adding partial seats.
   *
   * @param newTotal The new total number of seats
   */
  const updateUsedSeats = async (newTotal: number) => {
    isUpdatingUsedSeats.value = true
    try {
      await $api(`/api/businesses/${toValue(businessId)}/subscriptions/seats`, {
        method: 'PUT',
        body: { seats: newTotal },
      })
    } finally {
      isUpdatingUsedSeats.value = false
    }
  }

  return {
    usageData,
    isLoading,
    fetchUsageData,
    seatsAvailableForInvites,
    updateUsedSeats,
  }
}
